import logo from './images/home/logo.svg';
import logotext from './images/home/logotext.svg';
import logotext2 from './images/home/logotext2.svg';
import breadCrumb from './images/home/breadCrumb.svg';
import datePicker from './images/home/date-picker.svg';
import showPassword from './images/home/showPassword.svg';
import hiddenPassword from './images/home/hiddenPassword.svg';
import homeIcon from './images/home/home.svg';
import iconErrorPage from './images/home/error.png';

import menu from './images/sideBar/menu.svg';
import close from './images/sideBar/close.svg';
import person from './images/sideBar/person.png';
import agency from './images/sideBar/agency-account.png';
import newPost from './images/sideBar/new-post.png';
import management from './images/sideBar/management.png';
import messageMenu from './images/sideBar/message.png';
import adminPerson from './images/sideBar/admin-person.png';
import operationLog from './images/sideBar/operation-log.png';
import privacyPolicy from './images/sideBar/privacy-policy.png';
import usageInformation from './images/sideBar/usage-information.png';
import agencySidebar from './images/sideBar/agency-sidebar.png';
import parkSidebar from './images/sideBar/park.png';

import agencyUsageInformation from './images/sideBar/usage-information.png';
import agencyAgencyAccount from './images/sideBar/agency-account.png';

import companyUsageAccount from './images/sideBar/company_usage-information.svg';
import companyAgencyAccount from './images/sideBar/company_agency-account.svg';
import companyAdminAccount from './images/sideBar/company_setting-admin-account.svg';
import companyAttendanceInfo from './images/sideBar/company_attendance-information.svg';
import companyPrePaymentHistory from './images/sideBar/company_history-firstpay.svg';
import companyNotice from './images/sideBar/company_notice.svg';
import yenSideBar from './images/sideBar/yen.png';
import companySetting from './images/sideBar/company_setting.svg';
import moibuchoCompany from './images/sideBar/moibucho.svg';
import moibuchoOperator from './images/sideBar/moibhucho-operator.svg';
import moibuchoSideBar from './images/sideBar/moaibucho-white.svg';
import moai from './images/sideBar/moai.svg';
import moaiOperator from './images/sideBar/moai-operator.svg';
import moaiCompany from './images/sideBar/moai-company.svg';

import user from './images/header/user.png';
import message from './images/header/message.png';
import agencyNotification from './images/header/agency-notification.svg';
import agencyMessage from './images/header/message.png';
import agencyUser from './images/header/user.png';

import companyMessage from './images/header/message_company.svg';
import companyUser from './images/header/user_company.svg';
import companyNotification from './images/header/company-notification.svg';

import emaiImg from './images/home/email.svg';
import lock from './images/login/lock.svg';
import back from './images/login/back.svg';

import companyBack from './images/login/company_back.svg';

import search from './images/operator/search.svg';
import personOperator from './images/operator/person-operator.svg';
import noticeTitle from './images/operator/notice_title.svg';
import iconDetailCompany from './images/operator/detail-company.svg';

import down from './images/company/down.svg';
import noActive from './images/company/noActive.svg';
import whiteDown from './images/company/whiteDown.svg';
import warningVoice from './images/company/warning.svg';
import unTicked from './images/company/tick.svg';
import reject from './images/company/reject.svg';
import ticked from './images/company/ticked.svg';
import deleteCompany from './images/company/delete.svg';
import addCompany from './images/company/add.svg';
import searchFile from './images/company/search.svg';
import download from './images/company/download.svg';

import downEdit from './images/agency/down.svg';
import computer from './images/agency/computer.svg';
import question from './images/agency/question.svg';

import createAccount from './images/companySite/create-account.svg';
import createAccountWhite from './images/companySite/create-account-white.svg';
import backCompany from './images/companySite/back.svg';
import createAccountLineWhite from './images/companySite/create-account-line-white.svg';
import saveAccount from './images/companySite/save-account.svg';
import iconHide from './images/companySite/icon-hide.svg';
import iconShow from './images/companySite/icon-show.svg';
import iconSearch from './images/companySite/search.svg';
import settingCompany from './images/companySite/setting.svg';
import arrowBottomCompany from './images/companySite/arrow-bottom.svg';
import iconInfo from './images/companySite/info.svg';
import iconSettingSalaryType from './images/companySite/icon-setting-salary.svg';
import createMany from './images/companySite/create-many.svg';
import createAccountActive from './images/companySite/create-account-active.svg';
import warningWhite from './images/companySite/warning-white.svg';
import warningRed from './images/companySite/warning-red.svg';
import warningBrightRed from './images/companySite/warning-bright-red.svg';
import companySiteHome from './images/companySite/home.svg';
import managementTime from './images/companySite/management-time.svg';
import account from './images/companySite/account.svg';
import iconForm from './images/companySite/form.svg';
import timeHistory from './images/companySite/time-history.svg';
import attdendanceRecord from './images/companySite/attdendance-record.svg';
import downCompany from './images/companySite/down-company.svg';
import createStaff from './images/companySite/create-staff.svg';
import createStaffMany from './images/companySite/create-staff-many.svg';
import errorRed from './images/companySite/error-red.svg';
import companyAvatar from './images/companySite/avatar.svg';
import preIcon from './images/companySite/pre-icon.svg';
import nextIcon from './images/companySite/next-icon.svg';
import calendarCompany from './images/companySite/calendar-company.svg';
import nextIconPaging from './images/companySite/next.svg';
import nextIconPagingGreen from './images/companySite/next-green.svg';
import rushIcon from './images/companySite/rush.svg';
import checkPrivacyPolicy from './images/companySite/check.svg';
import downloadPrivacyPolicy from './images/companySite/download.svg';
import previewPrivacyPolicy from './images/companySite/preview.svg';
import privacyPolicyChecked from './images/companySite/privacy-policy-checked.svg';
import privacyPolicyNotCheck from './images/companySite/privacy-policy.svg';
import uploadDocument from './images/companySite/upload-document.svg';
import companySiteLogo from './images/companySite/logo.svg';
import rejectDocument from './images/companySite/reject.svg';
import companyLogoWithName from './images/companySite/logoWithName.svg';
import yenIcon from './images/companySite/yen-Icon.svg';
import companyWhiteLogoWithName from './images/companySite/whiteLogoWithName.svg';
import companyLogoHome from './images/companySite/home-logo.svg';
import companyLogin from './images/companySite/login.svg';
import companySendMail from './images/companySite/send-mail.svg';
import companyChangePass from './images/companySite/change-password.svg';
import oClock from './images/companySite/oclock.svg';
import nextRight from './images/companySite/next-right.svg';
import preLeft from './images/companySite/pre-left.svg';
import chatCompany from './images/companySite/chat.svg';
import tooltipSalaryType from './images/companySite/tooltip-salary_type.svg';
import tooltipDayAmountLimit from './images/companySite/tooltip-day_amount_limit.svg';
import tooltipDayAmountLimitOperator from './images/companySite/tooltip-day_amount_limit_operator.svg';
import tooltipMonthAmountLimit from './images/companySite/tooltip-month_amount_limit.svg';
import tooltipSalaryDay from './images/companySite/tooltip-salary_day.svg';
import tooltipSettingTimer from './images/companySite/tooltip-setting-timer.svg';
import settingTermOfUseCompany from './images/companySite/settingTermOfUse.svg';
import exclamationMark from './images/companySite/exclamation-mark.svg';
import topClock from './images/companySite/top-clock.svg';
import attendanceRecord from './images/companySite/attendance-record.svg';
import employeeList from './images/companySite/employee-list.svg';
import invoice from './images/companySite/invoice.svg';
import iconSelect from './images/companySite/icon-select.svg';
import warning from './images/companySite/warning.svg';
import tooltipLaterTransfer from './images/companySite/tooltip-later_transfer.svg';
import prevHour from './images/companySite/prev-hour.svg';
import nextHour from './images/companySite/next-hour.svg';
import nextMoon from './images/companySite/next-moon.svg';
import sun from './images/companySite/sun.svg';
import moon from './images/companySite/moon.svg';

import btnCloseModal from './images/common/btn-close-modal.svg';
import iconClose from './images/common/icon_close.svg';
import around from './images/common/around.svg';
import attach from './images/common/attach.svg';
import iconDocx from './images/common/icons-docx.png';
import iconCsv from './images/common/icons-csv.png';
import iconImage from './images/common/icons-image.png';
import iconPdf from './images/common/icons-pdf.png';
import iconXls from './images/common/icons-xls.png';
import iconFile from './images/common/icons-file.png';
import iconVideo from './images/common/icons-video.png';
import iconPpt from './images/common/icons-ppt.png';
import timeNext from './images/common/time-next.svg';
import timePre from './images/common/time-pre.svg';
import tooltipAdvanceName from './images/common/tooltip-advance-name.svg';
import tooltipAdvanceNameCompany from './images/common/tooltip-advance-name-conpany.svg';
import nextNovaSeal from './images/common/next-nova-seal.png';
import newNotice from './images/common/new-notice.svg';
import iconCopyLink from './images/common/copylink.png';
import maebaraiLogo from './images/common/maebarai-logo.png';

import settingIcon from './images/operatorSite/setting/setting.svg';
import searchIcon from './images/operatorSite/search.svg';
import messageTopPage from './images/operatorSite/message.svg';
import documentTopPage from './images/operatorSite/document.svg';
import searchFileTopPage from './images/operatorSite/search-file.svg';
import companyTopPage from './images/operatorSite/company.svg';
import memoryStick from './images/operatorSite/memory-stick.svg';
import memoryStickMonth from './images/operatorSite/memory-stick-month.svg';
import memoryStickSuspended from './images/operatorSite/memory-stick-suspended.svg';
import noticeTopPageOperator from './images/operatorSite/notice.svg';

import bigProfile from './images/agencySite/big-profile.svg';
import saveAgency from './images/agencySite/save.svg';
import agencyLogoWithName from './images/agencySite/logo_with_name.svg';
import agencyBack from './images/agencySite/back.svg';
import agencyTermOfUse from './images/agencySite/termOfUse.svg';
import agencyInvoice from './images/agencySite/invoice.svg';
import agencySearch from './images/agencySite/search.svg';

const home = {
  datePicker,
  hiddenPassword,
  showPassword,
  logo,
  logotext,
  logotext2,
  breadCrumb,
  homeIcon,
  iconErrorPage,
};
const sideBar = {
  menu,
  person,
  adminPerson,
  management,
  agency,
  messageMenu,
  newPost,
  privacyPolicy,
  usageInformation,
  operationLog,
  close,
  agencyAgencyAccount,
  agencyUsageInformation,
  companyAgencyAccount,
  companyUsageAccount,
  companySetting,
  companyNotice,
  companyAdminAccount,
  companyPrePaymentHistory,
  companyAttendanceInfo,
  agencySidebar,
  parkSidebar,
  yenSideBar,
  moibuchoCompany,
  moibuchoOperator,
  moai,
  moibuchoSideBar,
  moaiOperator,
  moaiCompany,
};
const header = {
  message,
  agencyMessage,
  companyMessage,
  user,
  agencyUser,
  companyUser,
  companyNotification,
  agencyNotification,
};
const login = {
  emaiImg,
  lock,
  back,
  companyBack,
};
const operator = {
  search,
  personOperator,
  noticeTitle,
  iconDetailCompany,
  messageTopPage,
  documentTopPage,
  searchFileTopPage,
  companyTopPage,
  memoryStick,
  memoryStickMonth,
  memoryStickSuspended,
  noticeTopPageOperator,
};
const company = {
  down,
  ticked,
  addCompany,
  deleteCompany,
  unTicked,
  searchFile,
  download,
  reject,
  noActive,
  whiteDown,
  warningVoice,
};

const companySite = {
  createAccount,
  backCompany,
  createAccountWhite,
  createAccountLineWhite,
  saveAccount,
  iconHide,
  iconShow,
  iconSearch,
  settingCompany,
  arrowBottomCompany,
  iconInfo,
  createMany,
  createAccountActive,
  warningRed,
  warningBrightRed,
  warningWhite,
  companySiteHome,
  account,
  iconForm,
  timeHistory,
  attdendanceRecord,
  createStaff,
  createStaffMany,
  errorRed,
  companyAvatar,
  downCompany,
  preIcon,
  nextIcon,
  managementTime,
  calendarCompany,
  nextIconPaging,
  nextIconPagingGreen,
  rushIcon,
  checkPrivacyPolicy,
  downloadPrivacyPolicy,
  companySiteLogo,
  previewPrivacyPolicy,
  privacyPolicyNotCheck,
  privacyPolicyChecked,
  uploadDocument,
  rejectDocument,
  companyLogoWithName,
  yenIcon,
  companyWhiteLogoWithName,
  companyLogoHome,
  companyLogin,
  companySendMail,
  companyChangePass,
  oClock,
  nextRight,
  preLeft,
  chatCompany,
  tooltipSalaryType,
  tooltipDayAmountLimit,
  tooltipMonthAmountLimit,
  tooltipSalaryDay,
  tooltipSettingTimer,
  settingTermOfUseCompany,
  exclamationMark,
  topClock,
  attendanceRecord,
  employeeList,
  invoice,
  iconSelect,
  tooltipDayAmountLimitOperator,
  warning,
  tooltipLaterTransfer,
  prevHour,
  nextHour,
  nextMoon,
  sun,
  moon,
  iconSettingSalaryType,
};

const common = {
  btnCloseModal,
  around,
  iconClose,
  attach,
  iconDocx,
  iconCsv,
  iconImage,
  iconPdf,
  iconXls,
  iconFile,
  iconVideo,
  iconPpt,
  timeNext,
  timePre,
  tooltipAdvanceName,
  tooltipAdvanceNameCompany,
  nextNovaSeal,
  newNotice,
  iconCopyLink,
  maebaraiLogo,
};
const setting = {
  settingIcon,
  searchIcon,
};

const dealerAgency = {
  downEdit,
  computer,
  question,
};

const agencySite = {
  user,
  bigProfile,
  saveAgency,
  agencyLogoWithName,
  agencyBack,
  agencyTermOfUse,
  agencyInvoice,
  agencySearch,
};

const images = {
  home,
  sideBar,
  header,
  login,
  operator,
  company,
  companySite,
  common,
  dealerAgency,
  setting,
  agencySite,
  tooltipAdvanceName,
};

export default images;
